export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7027.1ed3cf3a.jpg";